import getAccountManagementQuestionsChargeWarning from './getAccountManagementQuestionsChargeWarning/getAccountManagementQuestionsChargeWarning';
import { SURVEY_BUILDER_POPUP_TYPES } from './constants';
import getAccountManagementSampleSizeChargeWarning from './getAccountManagementSampleSizeChargeWarning/getAccountManagementSampleSizeChargeWarning';

export default (authState, newState) => {
  const surveyPermissionsCharge =
    newState &&
    newState.newState &&
    newState.newState.surveyPermissionsCharge &&
    newState.newState.surveyPermissionsCharge[newState.newState.survey.id]
      ? newState.newState.surveyPermissionsCharge[newState.newState.survey.id]
      : {};

  const {
    accountManagementQuestionsWarning,
    surveyQuestionsChargeAmount
  } = getAccountManagementQuestionsChargeWarning(
    authState.isAdmin,
    newState.newState.survey,
    newState.newState.surveyLists,
    authState.accountManagement,
    surveyPermissionsCharge,
    authState.defaultConstants.accountManagementDefaultPermissionValues
  );

  const {
    surveySampleSizeChargeAmount
  } = getAccountManagementSampleSizeChargeWarning(
    newState.newState.survey,
    authState.accountManagement,
    surveyPermissionsCharge,
    authState.defaultConstants.accountManagementDefaultPermissionValues
  );

  const surveyId = newState.newState.survey.id;
  const existingSurveyPermissionsCharge =
    newState.newState.surveyPermissionsCharge;
  const newStateData = {};

  const surveyTotalCharge =
    surveyQuestionsChargeAmount.total + surveySampleSizeChargeAmount.total;

  // Charge amount is always updated
  newStateData.surveyPermissionsCharge = {
    ...(existingSurveyPermissionsCharge || {}),
    [surveyId]: {
      ...(existingSurveyPermissionsCharge &&
      existingSurveyPermissionsCharge[surveyId]
        ? existingSurveyPermissionsCharge[surveyId]
        : {}),
      surveyQuestionsChargeAmount,
      surveySampleSizeChargeAmount,
      surveyTotalCharge
    }
  };

  if (accountManagementQuestionsWarning !== null) {
    newStateData.surveyBuilderPopup = {
      type: accountManagementQuestionsWarning
    };

    if (
      accountManagementQuestionsWarning ===
      SURVEY_BUILDER_POPUP_TYPES.SURVEY_UNPUBLISHED_QUESTIONS_ADDED
    ) {
      newStateData.surveyPermissionsCharge = {
        ...existingSurveyPermissionsCharge,
        [surveyId]: {
          unpublishedWarningShown: true
        }
      };
    }

    if (
      accountManagementQuestionsWarning ===
      SURVEY_BUILDER_POPUP_TYPES.NO_LICENCE_MORE_THAN_15
    ) {
      newStateData.surveyPermissionsCharge = {
        ...existingSurveyPermissionsCharge,
        [surveyId]: {
          noLicenceMoreThan15WarningShown: true
        }
      };
    }
  }
  return newStateData;
};
